import React from 'react'
import { Button, Card, Col } from 'react-bootstrap'
import { IoCheckmarkOutline } from "react-icons/io5";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { clearIndividualVerfication } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import swal from "sweetalert";
import notify from '../../../utils/notification';
import { useParams } from "react-router-dom";

const CleardCard = (userType) => {
    const { id } = useParams();
    const loginDetails = localStorage.getItem("login_Details");
    const loginFullDetails = JSON.parse(loginDetails);
    console.log("loginDetails",loginFullDetails?.user?.id);

    const handleClearedSubmitbtn = async () => {
        const payloadData = {
            client_id: loginFullDetails?.user?.client_id,
            registration_id: id,
            status: "pass"
        };

        try {
            const response = await clearIndividualVerfication(payloadData);

            if (response?.data?.status === true) {
                swal(`${response?.data?.message}`);
            } else {
                notify('error', response.data.message);
            }
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                notify('error', error.response.data.message);
            } else {
                notify('error', 'An unexpected error occurred. Please try again.');
            }
        }
    };
  return (
    <>
     <div className="row ">
                    <Col lg={12} className="mb-3">
                        <Card style={{ height: 'auto' }}>
                            <Card.Header>
                                <Card.Title> <IoCheckmarkOutline className="text-success" /> CASE:VERIFIED</Card.Title>
                            </Card.Header>
                            <Card.Body >
                                <div className="form-check d-flex justify-content-center">
                                    <div>
                                        <input className="form-check-input" type="checkbox" />
                                        <label className="form-check-label">
                                            I have checked,profile photo,form fields and documents provided in "Certify Application Form " section.(click on Submit button,if data is Certified)
                                        </label>
                                    </div>
                                </div>

                                <div className=" d-flex justify-content-end mt-3">
                                    <div>
                                        <Button onClick={handleClearedSubmitbtn}>
                                            Certify & Submit
                                        </Button>
                                        <strong>
                                            <p> <IoMdInformationCircleOutline className="text-warning" /> Form will be Sent to Principal</p>
                                        </strong>

                                    </div>

                                </div>
                            </Card.Body>
                        </Card>




                    </Col>


                </div>
    </>
  )
}

export default CleardCard